import { Box } from '@mui/material';
import { ComponentType } from 'react';
// import { useTranslation } from 'react-i18next';
import { TestQuestionsItem } from 'src/components/test/test-questions-item';
import useStyles from './styles';

interface TestsExpandedProps {
  item: Record<string, any>;
}
export const TestsExpanded: ComponentType<TestsExpandedProps> = ({ item }) => {
  const classes = useStyles();
  // const { t } = useTranslation();

  return (
    <Box className={classes.root}>
      <TestQuestionsItem
        hideQuestion
        striped
        disabled
        item={item}
      />
    </Box>
  );
};
